import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

export const orgchartOrganizationFieldPack: FieldPack = {
  id: 'orgchart-organization',
  name: 'Organizational Structure',
  description: 'Division, business unit, cost center, and location fields for reorg and workforce planning',
  version: '1.0.0',
  dependencies: ['orgchart-base'],
  fields: [
    {
      id: 'division',
      label: 'Division',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 80,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'businessUnit',
      label: 'Business Unit',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 75,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'subDepartment',
      label: 'Sub-Department',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 70,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'costCenter',
      label: 'Cost Center',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization'],
      priority: 65,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'location',
      label: 'Location',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization', 'location'],
      priority: 60,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'building',
      label: 'Building',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['location'],
      priority: 55,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'floor',
      label: 'Floor',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['location'],
      priority: 50,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'region',
      label: 'Region',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization', 'location'],
      priority: 45,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'country',
      label: 'Country',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['location'],
      priority: 40,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'timezone',
      label: 'Time Zone',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['location'],
      priority: 35,
      namespace: 'org',
      sensitivity: 'internal',
    },
    {
      id: 'workMode',
      label: 'Work Mode',
      type: FieldType.SELECT,
      tags: ['organization', 'employment'],
      priority: 30,
      namespace: 'org',
      options: [
        { value: 'onsite', label: 'On-site' },
        { value: 'remote', label: 'Remote' },
        { value: 'hybrid', label: 'Hybrid' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'legalEntity',
      label: 'Legal Entity',
      type: FieldType.SELECT,
      allowCustomOptions: true,
      tags: ['organization', 'compliance'],
      priority: 25,
      namespace: 'org',
      sensitivity: 'internal',
    },
  ],
};
